import './loader.scss';
import React from 'react';

export default function Loader({ fullpage }) {
    return (
        <React.Fragment>
            {fullpage && <div className="hto-loader-overlay"></div>}
            <div className={`hto-loader ${fullpage ? 'fullpage' : ''}`}>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
            </div>
        </React.Fragment>
    );
}
